export { genDoctor } from './doctor';
export { genBookingDataDoctor } from './bookindDataDoctor';
export { genPhonesDoctor } from './phonesDoctor';
export { genDoctorBookingSchedule } from './doctorBookingSchedule';
